import { SmartDataLogo, SmartDataLogoVariants } from '@ctek/design-system';
import { AssignmentKind } from 'century-core/core-apis/assignment/types';

export const SmartAssignmentIcon = ({
  kind,
  variant = SmartDataLogoVariants.MUTED,
}: {
  kind: AssignmentKind;
  variant?: SmartDataLogoVariants;
}) => (kind === 'Smart' ? <SmartDataLogo variant={variant} /> : null);
